import { useContext } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import { Home } from "./Pages/Home";
import Login from "./Pages/Login";
import Register from "./Pages/Register";


function App() {

  const {currentUser} = useContext(AuthContext)

  const ProtectedRoute = ({children}) => {
    if (!currentUser){
      return <Navigate to="/login" />;
    }

    return children 
  };

  return (
      <BrowserRouter> 
        <Routes>
          <Route path="/">
            <Route index 
              element={
                <ProtectedRoute>
                  <Home/>
                </ProtectedRoute> 
              } 
            />
            <Route path="login" element={<Login/>} />
            <Route path="register" element={<Register/>} />
          </Route>
        </Routes>
      </BrowserRouter>
    );
}

export default App;
